import React, { useEffect, useState } from "react";

const LineImages = ({ templateNumber }) => {

    return (
        <div>
            <img
                src={`assets/img/default_${templateNumber}.png`}
                alt={`default-${templateNumber}`}
                className="img-fluid line-default"
            />
            {Array.from({ length: templateNumber }, (_, index) => (
                <img
                    key={index + 1}
                    src={`assets/img/line${index + 1}.png`}
                    alt={`line-show-default-${index + 1}`}
                    // className={`img-fluid animate-blink line-show line-show${index + 1}`}
                    className={`img-fluid line-show line-show${index + 1} ${index + 1 === 1 ? 'active1' : " "} `}
                />
            ))}
        </div>
    );
};

export default LineImages;
